module.exports = __webpack_public_path__ + "images/TinyTacoTalking.1b4043f492b914f4b1f3.png";